import { Button } from "@/components/ui/button";
import { Shield } from "lucide-react";

export default function CookieBanner({ onAccept }) {
  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-50 bg-[#12202f] border-t border-[#3A4F60]/50 p-4 sm:p-6"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-start gap-3">
          <Shield className="w-5 h-5 text-[#C5993A] flex-shrink-0 mt-0.5" />
          <p className="text-[#8899AA] text-sm font-light">
            Diese Website benutzt technisch bedingte Cookies. Wenn Sie die Website weiter nutzen, gehen wir von Ihrem Einverständnis aus.{" "}
            <a href="/datenschutz" className="text-[#C5993A] hover:underline">
              Mehr erfahren
            </a>
          </p>
        </div>
        <Button
          data-testid="cookie-accept-button"
          onClick={onAccept}
          className="bg-gradient-to-r from-[#C5993A] to-[#8B6B20] text-white font-medium px-6 py-2 rounded hover:from-[#8B6B20] hover:to-[#C5993A] transition-all border-0 flex-shrink-0"
        >
          OK
        </Button>
      </div>
    </div>
  );
}
